import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-custom-form',
  templateUrl: './custom-form.component.html',
  styleUrls: ['./custom-form.component.scss']
})
export class CustomFormComponent implements OnInit, OnChanges {
  @Input() label: string;
  @Input() display = false;
  @Input() enviouForm = false;

  @Output() removeuCampo: EventEmitter<string> = new EventEmitter();
  @Output() adicionouCampo: EventEmitter<string> = new EventEmitter();
  @Output() alterouValorProposta: EventEmitter<string> = new EventEmitter();
  @Output() alterouValorJustificativa: EventEmitter<string> = new EventEmitter();

  formulario: FormGroup;

  constructor() { }

  ngOnInit(): void {
    this.criarFormulario();
  }

  ngOnChanges(changes: any) {
    if (changes.enviouForm.currentValue === true) {
      this.formulario.markAllAsTouched();
    }
  }

  criarFormulario() {
    this.formulario = new FormGroup({
      proposta: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      justificativa: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
    });
  }

  propostaValueChange(value: any) {
    this.alterouValorProposta.emit(value);
  }

  justificativaValueChange(value: any) {
    this.alterouValorJustificativa.emit(value);
  }

  addField() {
    this.display = true;
    this.adicionouCampo.emit();
  }

  removeField() {
    this.display = false;
    this.formulario.get('proposta').setValue('');
    this.formulario.get('justificativa').setValue('');
    this.formulario.get('proposta').markAsUntouched();
    this.formulario.get('justificativa').markAsUntouched();
    this.removeuCampo.emit();
  }

}
